import { Order, Orderable, OrderableType, SuborderResource } from '@data/orders/orders.model';
import { Stock } from '@data/stock/stock.model';
import { FleetResource } from '@data/fleets/fleets.model';
import { VehicleResource } from '@data/vehicles/vehicles.model';
import { Id } from '@core/http/crud-model';

export const suborderFactory = (resource: SuborderResource): Suborder => {
  return new Suborder(
    resource,
    new Stock(resource.confirmed ? resource.confirmed?.stock : null),
    new Order(resource.order),
  );
};

export class Suborder {
  constructor(
    private resource: SuborderResource,
    private stock: Stock = null,
    private order: Order = null,
  ) {}

  getQuantity(): number {
    return this.resource?.confirmed ? this.resource?.confirmed?.quantity : null;
  }

  getFleet(): FleetResource {
    return this.resource?.order?.fleet;
  }

  getVehicle(): VehicleResource {
    return this.resource?.order?.vehicle;
  }

  getStock(): Stock {
    return this.stock;
  }

  isWithPickup(): boolean {
    return !!this.resource?.with_pickup;
  }

  getId(): Id {
    return this.resource?.id;
  }

  getOrderable(): Orderable {
    return this.resource?.workshop || this.resource?.recipient || null;
  }

  getOrderableType(): OrderableType {
    return this.resource?.workshop ? OrderableType.WORKSHOP : this.resource?.recipient ? OrderableType.RECIPIENT : null;
  }

  getContactPersonName(): string {
    return this.resource?.order?.recipient_contact_person?.name;
  }

  getContactPersonPhoneNumber(): string {
    return this.resource?.order?.recipient_contact_person?.phone_number;
  }

  getContactPersonEmail(): string {
    return this.resource?.order?.recipient_contact_person?.email;
  }

  getNumber(): string {
    return this.resource?.number;
  }

  getOrderNumber(): string {
    return this.resource?.order?.order_number;
  }

  getResource(): SuborderResource {
    return this.resource;
  }

  getPrice(): string {
    return this.resource?.confirmed?.fleet_discounted_price;
  }

  getType(): string {
    return 'suborder';
  }
  getOrderableHeader(): string {
    if (this.resource?.workshop) {
      return this.resource.workshop.short_name;
    }

    if (this.resource?.recipient) {
      return this.resource.recipient.name;
    }

    return '';
  }

  getOrder(): Order {
    return this.order;
  }
}
